// extracted by mini-css-extract-plugin
module.exports = {"link":"e7C2r","image":"SlhNK","root":"_2sdRi","ScotchA":"_1UDui","scotchA":"_1UDui","ScotchB":"asxtt","scotchB":"asxtt"};